exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-style {\n    border-radius: 15px;\n    cursor: pointer;\n    background: #fff;\n    border: solid 1px #e9eaec;\n    padding: 10px 10px 10px 10px;\n    position: relative;\n    font-size: 11px;\n}\n", ""]);

// exports
